<section class="heading" data-testid="active-state-title">
  <app-dot-pulse />
  <p class="body bold">Please rebook</p>
</section>

<p class="body mt-8" data-testid="out-card-left-message">
  We're sorry, no-one was home when the engineer arrived. They left you a note about calling our repairer to book a new
  date.
</p>

@if (!vm.isMobile) {
  <p class="body mt-8">Call to rebook</p>
}

<app-telephone-link
  [largeFont]="true"
  postCodeMessagingClasses="max-w-480"
  [postCode]="vm.postCode"
  [phoneNumber]="vm.phone"
  [hidePostCodeMessaging]="!vm.isMobile"
  [useButtonOnMobile]="true"
  buttonLabel="Call to rebook"
/>
